import { IDomain } from './domain.i';

export class CDomain implements IDomain {
  id = 0;
  libelle = '';
  type = '';
  children: CDomain[] = [];
  parent: CDomain = null;

  constructor(source?: IDomain) {
    if (source) {
      Object.assign(this, {
        id: source.id,
        libelle: source.libelle,
        type: source.type,
        children: source.children ? [...source.children] : source.children,
        parent: source.parent
      });
    }
  }
}
